import useDialog from "hooks/dialog/useDialog";
import { useState } from "react";
import { useQueryClient } from "react-query";
import { deletePdc, updatePdc } from "services/api/api";

const useEditPowerDistributionCompany = (controller, onSuccess) => {
  const queryClient = useQueryClient();
  const [updateRequestLoading, setUpdateRequestLoading] = useState(false);
  const isDisabled = false;

  const { clearAllFields, updateLoadingToast, initializeLoadingToast } = controller;

  const handleUpdateClick = async () => {
    let updateToastId;
    try {
      const {
        price,
        powerDistributionCompanyName,
        state,
        hasProcessing,
        hasADifferentPrice,
        powerDistributionCompany,
        engineer,
      } = controller.values();

      setUpdateRequestLoading(true);
      updateToastId = initializeLoadingToast({
        text: `Atualizando Concessionária...`,
      });

      const processing = hasProcessing === true ? 1 : 0;

      const differentARTPrice = hasADifferentPrice === true ? 1 : 0;

      const { status } = await updatePdc(
        powerDistributionCompany.id,
        powerDistributionCompanyName,
        state.id,
        processing,
        differentARTPrice,
        price,
        engineer.id
      );

      if (status === 200) {
        // Não limpa os campos em modo de edição - mantém os dados atualizados visíveis
        // clearAllFields();
        queryClient.invalidateQueries({ queryKey: ["baseDataQuery"] });

        updateLoadingToast({
          id: updateToastId,
          text: `Concessionária Atualizada com sucesso`,
          type: "success",
        });

        // Chamar callback de sucesso após um delay para mostrar o toast
        if (onSuccess) {
          setTimeout(() => {
            onSuccess();
          }, 1000);
        }
      }
    } catch (error) {
      updateLoadingToast({
        id: updateToastId,
        text: error.response?.data?.message ?? `Erro ao atualizar Concessionária, tente novamente`,
        type: "error",
      });
    } finally {
      setUpdateRequestLoading(false);
    }
  };

  const [deleteRequestLoading, setDeleteRequestLoading] = useState(false);
  const { open: dialogOpen, handleClickOpen, handleClickClose } = useDialog();

  const handleDeleteClick = async () => {
    let deleteToastId;
    try {
      setDeleteRequestLoading(true);
      deleteToastId = initializeLoadingToast({
        text: `Excluindo Concessionária...`,
      });

      const { powerDistributionCompany } = controller.values();

      const { status } = await deletePdc(powerDistributionCompany.id);

      if (status === 200) {
        clearAllFields();
        queryClient.invalidateQueries({ queryKey: ["baseDataQuery"] });

        updateLoadingToast({
          id: deleteToastId,
          text: `Concessionária Excluída com sucesso`,
          type: "success",
        });

        // Chamar callback de sucesso após um delay
        if (onSuccess) {
          setTimeout(() => {
            onSuccess();
          }, 1000);
        }
      }
    } catch (error) {
      updateLoadingToast({
        id: deleteToastId,
        text: error.response?.data?.message ?? `Erro ao Excluir Concessionária, tente novamente`,
        type: "error",
      });
    } finally {
      setDeleteRequestLoading(false);
      handleClickClose();
    }
  };

  return {
    updateRequestLoading,
    deleteRequestLoading,
    open: dialogOpen,
    isDisabled,

    handleUpdateClick,
    handleDeleteClick,

    handleClickClose,
    handleClickOpen,
  };
};

export default useEditPowerDistributionCompany;
